/*
 * @Descripttion: 
 * @version: 
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-23 09:04:20
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2020-12-29 16:19:13
 */
import request from './request'
// let base = 'https://aneuplan.arteryflow.com/AneuPlan';
// let base = '/api';
let base;
if(process.env.NODE_ENV == 'development'){//开发
    base = process.env.BASE_URL;
}else{//线上
    base = process.env.BASE_URL;
//     base = process.env.TEST_URL;
}

// 
export const GetCaseList = (params, callBack, self, extraData) => { return request.Get(`${base}/caseList`, params, callBack, self, extraData) };

// 登录
export const GetLogin = (params, callBack, self, extraData) => { return request.Post(`${base}/user/logining`, params, callBack, self, extraData) };
// 修改用户名称
export const SetPassword = (params, callBack, self, extraData) => { return request.Post(`${base}/user/setPassword`, params, callBack, self, extraData) };
// 用户列表
export const GetfindUserAll = (params, callBack, self, extraData) => { return request.Post(`${base}/user/findAll`, params, callBack, self, extraData) };
// 用户列表：根据权限查找
export const GetfindByPermission = (params, callBack, self, extraData) => { return request.Post(`${base}/user/findByPermission`, params, callBack, self, extraData) };
// 根据id查找用户详细详细
export const GetUserById = (params, callBack, self, extraData) => { return request.Post(`${base}/user/findById`, params, callBack, self, extraData) };
/************************************************************ */

/**
 * 
 * @param {*病例列表} params 
 * @param {*} callBack 
 * @param {*} self 
 */
// 病例列表:根据条件查询数据
export const GetfindPatientList = (params, callBack, self, extraData) => { return request.Post(`${base}/patient/findPatientList`, params, callBack, self, extraData) };
/**
 * @param {病例分配}} 
 * @param {id,bid,permission} 
 */
export const SetDistribution = (params, callBack, self, extraData) => { return request.Post(`${base}/patient/distribution`, params, callBack, self, extraData) };


/************************************************************ */
/**
 * 
 * @param {*病例详情} params 
 * @param {*} callBack 
 * @param {*} self 
 */
export const GetFindByBid = (params, callBack, self, extraData) => { return request.Post(`${base}/patient/findByBid`, params, callBack, self, extraData) };
/**
 * @param {病例步骤下一步} 
 * @param {bid,progress}  
 */
export const SetPatientNext = (params, callBack, self, extraData) => { return request.Post(`${base}/patient/next`, params, callBack, self, extraData) };
/**
 * @param {病例审核} 
 * @param {bid,examine}  
 */
export const SetToExamine = (params, callBack, self, extraData) => { return request.Post(`${base}/patient/toExamine`, params, callBack, self, extraData) };
/**
 * @param {病例完成接口} 
 * @param {bid,url}  
 */
export const SetCaseCompletion = (params, callBack, self, extraData) => { return request.Post(`${base}/patient/caseCompletion`, params, callBack, self, extraData) };
/**
 * @param {添加结果案例上传路径接口} 
 * @param {bid,blood(血管),coil(弹簧圈),stent(支架),video(视频),screenshot(截图),pdf}  
 */
export const addResult = (params, callBack, self, extraData) => { return request.Post(`${base}/patient/addResult`, params, callBack, self, extraData) };
/************************************************************ */
/**
 * 
 * @param {*新建病例} params 
 * @param {*} callBack 
 * @param {*} self 
 */
// 新建病例 参数：
export const AddPatient = (params, callBack, self, extraData) => { return request.Post(`${base}/patient/addPatient`, params, callBack, self, extraData) };
// 影像文件上传 参数:uploadFile,nickname,id,bid,condition(分类：新建病例)
export const Upload = (params, callBack, self, extraData) => { return request.Post(`${base}/patient/upload`, params, callBack, self, extraData) };
/************************************************************ */


// WEBPACK FOOTER //
// ./src/api/api.js